module.exports = __webpack_public_path__ + "img/1594364877.b8fd4aed.jpg";